import * as React from 'react';

import { AlertSquareSVG } from '@components/svgs';
import { Tooltip } from '@components/Tooltip';
import { useAccount } from '@hooks/useAccount';
import { useFeature } from '@hooks/useFeature';

import { notOnTeamHeading } from '../utils';

interface Props {
  teamUsersNotOnStudyTeamCount: number;
}

export const CollaboratorNotOnTeamIcon: React.FC<Props> = ({ teamUsersNotOnStudyTeamCount }) => {
  const hasTeamAccessControl = useFeature('team_access_control');
  const { account } = useAccount();

  if (!hasTeamAccessControl || teamUsersNotOnStudyTeamCount <= 0) return null;

  return (
    <Tooltip content={notOnTeamHeading(teamUsersNotOnStudyTeamCount, account.visibility_permission_condition)}>
      <AlertSquareSVG className='red-600 ml-2' />
    </Tooltip>
  );
};
